export default "__VITE_ASSET__Svc$QKO7__"